/* tslint:disable */
/* eslint-disable */
/**
 * Sistema de Recadastramento Agenda Assessoria - RecadOnlineBack - DESENVOLVIMENTO
 * Facilitar o Recadastramento dos Servidores Efetivos.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AwsCompareFaces } from '../models';
// @ts-ignore
import { AwsCompareFacesResponse } from '../models';
/**
 * AwsApi - axios parameter creator
 * @export
 */
export const AwsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AwsCompareFaces} awsCompareFaces 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareFaces: async (awsCompareFaces: AwsCompareFaces, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awsCompareFaces' is not null or undefined
            assertParamExists('compareFaces', 'awsCompareFaces', awsCompareFaces)
            const localVarPath = `/aws/faces/compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(awsCompareFaces, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AwsApi - functional programming interface
 * @export
 */
export const AwsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AwsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AwsCompareFaces} awsCompareFaces 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareFaces(awsCompareFaces: AwsCompareFaces, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AwsCompareFacesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareFaces(awsCompareFaces, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AwsApi - factory interface
 * @export
 */
export const AwsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AwsApiFp(configuration)
    return {
        /**
         * 
         * @param {AwsCompareFaces} awsCompareFaces 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareFaces(awsCompareFaces: AwsCompareFaces, options?: any): AxiosPromise<AwsCompareFacesResponse> {
            return localVarFp.compareFaces(awsCompareFaces, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AwsApi - object-oriented interface
 * @export
 * @class AwsApi
 * @extends {BaseAPI}
 */
export class AwsApi extends BaseAPI {
    /**
     * 
     * @param {AwsCompareFaces} awsCompareFaces 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsApi
     */
    public compareFaces(awsCompareFaces: AwsCompareFaces, options?: AxiosRequestConfig) {
        return AwsApiFp(this.configuration).compareFaces(awsCompareFaces, options).then((request) => request(this.axios, this.basePath));
    }
}
